module.exports = __webpack_public_path__ + "img/IMG_9512_L_Black.742b1247.jpg";